// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"0d11bac2","543":"9e069e3c","584":"c33906b7","743":"fdcc71ab","884":"281fec98","987":"722b13d1"}[chunkId] + ".chunk.css";
};